<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter justify-center items-center">
        <div class="vx-col sm:w-2/3 md:w-2/3 lg:w-1/4 m-4">
            <vx-card>
                <div class="vx-card__title mb-6">
                    <h2 class="text-center">开通学校（机构）申请</h2>
                </div>
                <img src="../../assets/images/pages/rocket.png" alt="coming-soon" class="mx-auto mb-2" width="150">
                <div>
                    <p>您还没有“HAAI学堂”的使用权限！如果您是学校（机构）的负责人并且想体验使用“HAAI学堂”，请填写以下表单并且保持电话畅通。我们的客服会与您联系！</p>
                    <vs-input type="text" label-placeholder="姓名" v-model="postData.name" class="w-full pt-2" />
                    <vs-input type="phone" label-placeholder="联系电话" v-model="postData.phone" class="w-full pt-2" />
                    <vs-input type="text" label-placeholder="学校(机构)名称" v-model="postData.school" class="w-full py-2" />
                    <v-select class="w-full my-4" :options="freeTimeOption" v-model="postData.free_time" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                    <vs-button class="w-full" @click="submit" :disabled="!allowedSubmit">提交</vs-button>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import { post } from '@/api/apply'
import config from '@/config'
import vSelect from 'vue-select'
export default {
    data() {
        return {
          postData: {
            name: '',
            phone: '',
            school: '',
            free_time: '9:00 ~ 15:00',
          },
          freeTimeOption: [
            '9:00 ~ 15:00',
            '18:00 ~ 22:00',
            '全天24小时'
          ],
          allowedSubmit: true,
        }
    },
    components: {
        'v-select': vSelect,
    },
    methods: {
      submit() {
        this.allowedSubmit = false
        post(this.postData).then(res => {
          if (res.code == 1) {
             this.$vs.notify({
              color: "success",
              text: res.msg,
              title: "提示",
              iconPack: "feather",
              icon: "icon-alert-circle",
            });
            setTimeout(() => {
              window.location.href = config.shequUrl
            }, 2000);
          } else {
            this.allowedSubmit = true
          }
        })
      }
      
    }
}
</script>
